import { MenuItem as MuiMenuItem, Stack } from '@mui/material';

import { styled } from '@/theme/styled';

const MenuItem = styled(MuiMenuItem)(({ theme }) => ({
  gap: theme.spacing(1),
  padding: theme.spacing(0),
  height: 32,

  '[data-cy="actions-menu"]': {
    display: 'none',
  },

  '&:hover [data-cy="actions-menu"]': {
    display: 'block',
  },
}));

const TeamResource = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
}));

const TeamResourceName = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export { MenuItem, TeamResource, TeamResourceName };
